import { issueInvoicePageViewList } from "pages/IssueInvoice/utils";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListInvoiceTickets = () => {
  const [filterList, setFilterList] = useState({});

  const [khhdonDefault, setKhhdonDefault] = useState(null);
  const [pageView, setPageView] = useState(null);

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
      let curYear = new Date().getFullYear().toString();
      curYear = curYear?.substr(curYear.length - 2);
      switch (finalBuInfo?.invoice_type) {
        case 1:
          setKhhdonDefault(`C${curYear}G`);
          setPageView(issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE);
          break;
        case 0:
          setKhhdonDefault(`K${curYear}G`);
          setPageView(issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE);
          break;
        default:
          break;
      }
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        title={"TEM PHIẾU"}
        pageView={pageView}
        khhdonDefault={khhdonDefault}
        titleManger={"HÓA ĐƠN KHÁC"}
      />
    </React.Fragment>
  );
};

export default ListInvoiceTickets;
